export class NoMetricsError extends Error {
  constructor(message: string) {
    super(message);

    this.name = "NoMetricsError";
  }
}
